import { Schema as S } from "effect";
export const Schema = S.Number.pipe(S.brand("@open-revenue/schema/ApplicationId"), S.annotations({
    description: "A unique identifier for an application, supplied by the developer"
}));
export const SchemaString = S.String.pipe(S.brand("@open-revenue/schema/ApplicationId"), S.annotations({
    description: "A unique identifier for an application, supplied by the developer"
}));
export const FromString = S.compose(S.NumberFromString, Schema);
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeString = (id)=>S.decodeUnknown(SchemaString)(id);
export const makeUnsafe = (id)=>id;
export const makeUnsafeString = (id)=>id;
